import { OrgPartSchema } from 'types/clientV2/parts';

export const isOrgPartSchema = (
  part: OrgPartSchema | string | undefined
): part is OrgPartSchema =>
  typeof part === 'object' &&
  part !== null &&
  'id' in part &&
  'cofactrId' in part;

export const findV2OrgPartById = (
  v2OrgParts: (OrgPartSchema | string)[] | undefined,
  id: string | undefined
): OrgPartSchema | undefined => {
  if (!id) {
    return undefined;
  }
  return v2OrgParts?.find(
    (part): part is OrgPartSchema => isOrgPartSchema(part) && part.id === id
  );
};

export const findV2OrgPartByCofactrId = (
  v2OrgParts: (OrgPartSchema | string)[] | undefined,
  cofactrId: string
): OrgPartSchema | undefined =>
  v2OrgParts?.find(
    (part): part is OrgPartSchema =>
      isOrgPartSchema(part) && part.cofactrId === cofactrId
  );
